export function range(start: number, end: number) {
    // assert that start is less than end
    if (start > end) {
        throw new Error('Start must be less than end')
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}
